import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { downloadFileAction } from '@schir-int-client/binary-shared';
import { doNothingAction } from '@schir-int-client/ngrx-helpers';
import { DialogService } from '@schir-int-client/tech';
import { VerfahrenFacade } from '@schir-int-client/verfahren-shared';
import { AufgabeFacade } from 'libs/aufgabe-shared/src/lib/aufgabe.facade';
import { map, mergeMap, switchMap, withLatestFrom } from 'rxjs/operators';
import {
	askToDeleteKorrespondenzVorlageAction,
	createKorrespondenzVorlageAction,
	createKorrespondenzVorlageSuccessAction,
	deleteKorrespondenzVorlageAction,
	deleteKorrespondenzVorlageSuccessAction,
	downloadKorrespondenzVorlageAction,
	loadKorrespondenzVorlageAction,
	loadKorrespondenzVorlageSuccessAction,
} from './korrespondenz-vorlage.actions';
import { KorrespondenzVorlageMessages } from './korrespondenz-vorlage.messages';
import { KorrespondenzVorlageService } from './korrespondenz-vorlage.service';
import { getIdNumber } from '../../../../test-helpers/src/lib/resource-helper';

@Injectable()
export class KorrespondenzVorlageEffects {
	constructor(
		private actions: Actions,
		private service: KorrespondenzVorlageService,
		private aufgabeFacade: AufgabeFacade,
		private verfahrenFacade: VerfahrenFacade,
		private dialogService: DialogService
	) {}

	loadKorrespondenzVorlage = createEffect(() =>
		this.actions.pipe(
			ofType(loadKorrespondenzVorlageAction),
			mergeMap(({ aufgabe }) => {
				return this.service
					.loadKorrespondenzVorlage(aufgabe)
					.pipe(map(korrespondenzVorlage => loadKorrespondenzVorlageSuccessAction({ korrespondenzVorlage })));
			})
		)
	);

	createKorrespondenzVorlage = createEffect(() =>
		this.actions.pipe(
			ofType(createKorrespondenzVorlageAction),
			withLatestFrom(this.verfahrenFacade.verfahrenSingle, this.aufgabeFacade.aufgabe),
			switchMap(([{ korrespondenzVorlage, vorlageId }, verfahren, aufgabe]) => {
				return this.service
					.createKorrespondenzVorlage(aufgabe, korrespondenzVorlage, vorlageId, getIdNumber(verfahren))
					.pipe(map(() => createKorrespondenzVorlageSuccessAction()));
			})
		)
	);

	downloadKorrespondenzVorlage = createEffect(() =>
		this.actions.pipe(
			ofType(downloadKorrespondenzVorlageAction),
			withLatestFrom(this.aufgabeFacade.aufgabe),
			switchMap(([, aufgabe]) =>
				this.service
					.downloadKorrespondenzVorlage(aufgabe)
					.pipe(map(binaryFile => downloadFileAction({ binaryFile })))
			)
		)
	);

	confirmDeleteKorrespondenz = createEffect(() =>
		this.actions.pipe(
			ofType(askToDeleteKorrespondenzVorlageAction),
			switchMap(({ korrespondenzVorlage }) => {
				return this.dialogService
					.openConfirmationDialog(KorrespondenzVorlageMessages.ASK_TO_DELETE_KORRESPONDENZ_VORLAGE)
					.pipe(
						map(confirmed =>
							confirmed ? deleteKorrespondenzVorlageAction({ korrespondenzVorlage }) : doNothingAction()
						)
					);
			})
		)
	);

	deleteKorrespondenz = createEffect(() =>
		this.actions.pipe(
			ofType(deleteKorrespondenzVorlageAction),
			switchMap(({ korrespondenzVorlage }) => {
				return this.service
					.deleteKorrespondenzVorlage(korrespondenzVorlage)
					.pipe(map(() => deleteKorrespondenzVorlageSuccessAction({ korrespondenzVorlage })));
			})
		)
	);
}
